// Voice id, quality-tier, and engine-budget types shared across modules. Per-voice
// envelope feedback (rms/pitch/active) flows engine -> app as an EnvelopeSnapshot via
// postMessage (see src/engine/resonator-node.ts) — not a SharedArrayBuffer, so no
// cross-origin isolation (COOP/COEP) is required.

export type VoiceId = number;

/** Engine DSP budget tier. */
export type QualityTier = 'desktop' | 'mobile';

/** Visuals render-quality tier. */
export type VisualQualityTier = 'high' | 'medium' | 'low';

/** Product-level tier; maps down to engine QualityTier + VisualQualityTier. */
export type AppTier = 'desktop-high' | 'desktop-mid' | 'mobile';

/** Engine budgets per tier. */
export interface EngineBudget {
  maxVoices: number;
  modesCap: number;
  maxActiveModes: number;
}

export const ENGINE_BUDGETS: Record<QualityTier, EngineBudget> = {
  desktop: { maxVoices: 12, modesCap: 24, maxActiveModes: 400 },
  mobile: { maxVoices: 6, modesCap: 20, maxActiveModes: 120 },
};
